import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-syllabus',
  templateUrl: './download-syllabus.component.html',
  styleUrls: ['./download-syllabus.component.scss']
})
export class DownloadSyllabusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
